import React, { memo } from "react";
import SectionWrapper, { type SectionWrapperPropagationProps } from "../../../common/section-wrapper/SectionWrapper";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";
import Grades from "./subsections/grades/Grades";
import styles from "../../../common/section-wrapper/SectionWrapper.module.scss";
import Colour from "./subsections/colours/Colour";
import Upholstery from "./subsections/upholstery/Upholstery";
import Wheels from "./subsections/wheels/Wheels";
import { useComponentRegistry } from "../../../componentRegistry";

const Atmosphere: React.FC<SectionWrapperPropagationProps<CarConfigConfigureSectionsLbx>> = ({
    sectionRefs,
}): JSX.Element => {
    const Hero = useComponentRegistry("AtmosphereHero");

    return (
        <SectionWrapper
            sectionId={CarConfigConfigureSectionsLbx.AtmosphereWelcome}
            sectionRef={sectionRefs.get(CarConfigConfigureSectionsLbx.AtmosphereWelcome)}
        >
            <div className={styles.subsections}>
                <Hero sectionRefs={sectionRefs} />
                <Grades sectionRefs={sectionRefs} />
                <Colour sectionRefs={sectionRefs} />
                <Upholstery sectionRefs={sectionRefs} />
                <Wheels sectionRefs={sectionRefs} />
            </div>
        </SectionWrapper>
    );
};

export default memo(Atmosphere);
